import * as types from '../action-types'
import Vue from 'vue'
import { API_URL } from '../../api'

const state = {
  sideBarMinimized: null,
  versionNumber: "4.2",
  dashboardStatistics: {
    statistics: [],
    getDashboardStatisticsStatus: null,
    gettingDashboardStatistics: false
  },
  config: {
    version: '1.0',
  },
  api: {
    isOnline: true
  },
}

const mutations = {
  [types.SET_API_AVAILABILITY](state, availability) {
    state.api.isOnline = availability
  },
  'SET_SIDEBAR_STATUS'(state, status) {
    state.sideBarMinimized = status
  },
  ['SET_DASHBOARD_STATISTICS_SEARCH'](state, change) {
    state.dashboardStatistics = { ...state.dashboardStatistics, ...change };
  }
}

const actions = {
  checkApiAvailability: ({ commit }) => {
    // console.log('checking Api')
    return Vue.http.get('/api')
      .then(response => {
        if (response.status === 0) {
          commit(types.SET_API_AVAILABILITY, false)
        } else {
          commit(types.SET_API_AVAILABILITY, true)
        }
      })
  },

  getDashboardStatistics: ({ commit }) => {
    commit('SET_DASHBOARD_STATISTICS_SEARCH', { getDashboardStatisticsStatus: null, statistics: [], gettingDashboardStatistics: true })
    return Vue.http.get('/api/dashboard-statistics').then(response => {
      commit('SET_DASHBOARD_STATISTICS_SEARCH', { getDashboardStatisticsStatus: 'success', statistics: response.body.results.statistics });
    }).catch(response => {
      commit('SET_DASHBOARD_STATISTICS_SEARCH', { getDashboardStatisticsStatus: 'failed' });
    }).finally(() => {
      commit('SET_DASHBOARD_STATISTICS_SEARCH', { gettingDashboardStatistics: false });
    })
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/appStore.js